import React from 'react'
import produce from 'immer'
import { debounce } from 'libraries/lodash'

const SmartFcFaqReferenceLink = ({
  setFaqExpandedNodeIds,
  setFaqScrollToId,
  expandedNodeIds,
  groupMap,
  attribs,
  children
}) => {
  const { href } = attribs

  const handleOnClick = () => {
    const id = '#' + href.split('faq/')[1]
    setFaqScrollToId(id)
    setFaqExpandedNodeIds(expandedNodeIds.filter(nodeId => nodeId !== id))

    const debounceThis = debounce(() => {
      const expandIds = produce(expandedNodeIds, draft => {
        let _id = id
        do {
          draft.push(_id)
          _id = groupMap.get(_id)
        } while (_id !== null)
      })
      setFaqExpandedNodeIds(expandIds)
    }, 20)
    debounceThis()
  }

  return (
    <a
      className='fc-faq-anchor pointer'
      href={null}
      onClick={handleOnClick}
    >
      {children}
    </a>
  )
}

export default SmartFcFaqReferenceLink
